import {
  BaseLogo,
  getLogoColors,
  getLogoState,
  hasUserPendingApprovalStatus,
  getTransferDisplayName,
  ImageLogo,
  isDigital,
  LogoEditStatus,
  LogoState,
  LogoType,
  NameLogo,
} from "../../../../core/models/entities/BaseLogo";
import {
  CSSProperties,
  Dispatch,
  JSX,
  SetStateAction,
  useEffect,
  useState,
} from "react";
import IconButton from "../../../components/LogoButton/IconButton";
import { enviroment } from "../../../../enviroment";
import {
  getMethodLabel,
  getTypeLabelFromRaw,
} from "../../../../utils/functions/logoListI18n";
import {
  canEditCommittedNavLogo,
  canLogoRejectAndEdit,
  canRejectAndEditCommittedNavLogo,
  isLogoNavWriteBackPending,
} from "../../../../utils/functions/logoRejectAndEdit";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCartPlus,
  faCheck,
  faClone,
  faDownload,
  faFile,
  faForward,
  faList,
  faShare,
  faShirt,
  faTrash,
  faTriangleExclamation,
} from "@fortawesome/free-solid-svg-icons";
import {
  faNoteSticky,
  faPenToSquare,
} from "@fortawesome/free-regular-svg-icons";
import { BoxHeader2 } from "../../../components/BoxView/BoxHeader2";
import {
  ColumnTypography,
  TypographyR,
} from "../../../components/Typographies/SectionHeaderTypography";
import { formatDate } from "../../../../utils/functions/DateUtil";
import { LogoStatusElement } from "../../../components/Logo/LogoStatusElement";
import { LogoDetailStorage } from "../../../components/Logo/LogoDetailStorage";
import { PriceRefreshNowButton } from "../../../components/Logo/PriceRefreshNowButton";
import {
  LogoPrices,
  PricesShort,
  SimplePriceLine,
} from "../../../components/Logo/LogoPrices";
import { LogoTitleHeader } from "../../../components/Logo/LogoTitleHeader";
import { LogoTransferMethod } from "../../../components/Logo/LogoTransferMethod";
import { StrucCol } from "../../../components/StructureElements/StrucCol";
import { StrucRow } from "../../../components/StructureElements/StrucRow";
import { LogoImage } from "../../../components/Logo/LogoImage";
import { DigitalColorElement } from "../../../components/Logo/DigitalColorElement";
import { VectorColorElement } from "../../../components/Logo/VectorColorElement";
import { Switch } from "../../../components/ui/Switch";
import { getProductPrice } from "../../../../core/models/entities/BaseLogo";
import {
  ApprovalVoting,
  Verdict,
} from "../../../components/ApprovalVoting/approval-voting";
import { LogoDimensions } from "../../../components/Logo/LogoDimensions";
import {
  ProductPendingBadge,
  ProductPendingLock,
} from "../../../components/Logo/ProductPendingBadge";
import { UploadFailedBadge } from "../../../components/Logo/UploadFailedBadge";
import { NavWriteBackPendingBadge } from "../../../components/Logo/NavWriteBackPendingBadge";
import { UploadRejectedDialog } from "../../logo-editor/componenets/UploadRejectedDialog";
import {
  isLogoActionLocked,
  isLogoProductPending,
  isLogoUploadPending,
  isUploadRejected,
  logoActionLockVariant,
} from "../../../../utils/functions/productPending";
import { LogoSharingInfoSection } from "../../../components/Logo/LogoSharingInfoSection";
import { Role } from "../../../../core/models/entities/Role";
import LoadingElement from "../../../components/loading-element/loading-element";
import { useProfileContext } from "../../../../contexts/ProfileContext";
import { BoxModalContent } from "../../../components/BoxView/BoxModalContent";
import { Stepper } from "../../../components/Buttons/Stepper";
import { EditIcon } from "../../../../resources/icons/Icons";
import { useTranslation } from "react-i18next";
import { isEmbroideryTransferType } from "../../../../utils/systemColors";
import { useLogoContext } from "../../design-editor2/contexts/logo-options.context";
import EmailDialog from "../../../components/Approval/EmailDialog";
import {
  getLogoMinQuantity,
  isValidLogoQuantity,
} from "../../../../utils/functions/QuantityUtil";
import { ApprovalConfirmationDialog } from "../../../components/Dialogs/ApprovalConfirmationDialog";
import { ApprovalStatus } from "../../../../core/models/entities/Approval";
import { LogoPdfGenerator } from "../../../../utils/functions/pdf-generator.service";
import { useWhiteLabelContext } from "../../../../WhiteLabelContext";
import { useApiClient } from "../../../../data/clients/ApiClient";
import { usePdfDownloadWithSharpGate } from "../../../../hooks/usePdfDownloadWithSharpGate";
import { usePriceVisibility } from "../../../../contexts/PriceVisibilityContext";
import { useSalesMarkup } from "../../../../hooks/useSalesMarkup";
import { useAddLogoToOrderDialog } from "../../../components/Dialogs/add-logo-to-design-order-dialog";
import { useCartHidden } from "../../../../hooks/useCartHidden";
import {
  OversizeSheetInlineRequest,
  useOversizeSheetInline,
} from "../../../components/OversizeSheet/oversize-sheet-inline-request";
import { shouldAllowCloning } from "../../../shared/functions/shouldAllowCloning";
import { Tooltip } from "@mui/material";
import { AssignCustomerDialog } from "../../../components/Dialogs/assign-customer-dialog";
import { useDialog } from "../../../components/Dialogs/dialog-base";
import { isPlaceholder } from "../../../../core/models/entities/BaseLogo";
import { faUserPlus } from "@fortawesome/free-solid-svg-icons";
import { ConfirmationGuard } from "../../../components/ConfirmationGuard";
import { orderLineTitleText } from "../../order-details/subcomponents/OrderLineData";
import { UnassignCustomerButton } from "./unassign-customer-button.component";
import { CLARITY_MASK } from "../../../../utils/analytics/clarityAttrs";

// Lifecycle of the background GetLogo that completes the list-row data the
// modal opened with. "loading" = fetch in flight, "ready" = full data shown,
// "error" = fetch failed and we keep rendering the list data (which is
// complete except for designCount and the fresh high-res render).
export type LogoDetailStatus = "loading" | "ready" | "error";

interface LogoDetails_VM {
  logo: BaseLogo;
  detailStatus: LogoDetailStatus;
  onPlaceVerdict: (logo: BaseLogo, verdict: Verdict) => void;
  onAddToCart: (logo: BaseLogo, quantity: number) => void;
  onEditLogo: (logo: BaseLogo) => void;
  onTitleChange: (title: string) => void;
  onDeleteLogo: (logo: BaseLogo) => void;
  onCopyLogo: (logo: BaseLogo) => void;
  // Send Approval should not be reused in the button layout, but the props interface is...
  onSendApproval: (logo: BaseLogo, email: string) => void;
  onViewDesigns: (logo: BaseLogo) => void;
  onShowRejectionNote: (logo: BaseLogo) => void;
  onSkipApproval: (logo: BaseLogo) => void;
  isLoading: boolean;
  onRejectAndDelete: (logo: BaseLogo, note?: string) => Promise<void>;
  // "Reject and fix it myself" (flag REACT_APP_LOGO_REJECT_AND_EDIT_ENABLED):
  // the wrapper's handler - ONE verdict PUT with editAfterReject:true, then
  // the editor of the SAME logo. Optional: the reject dialog shows the third
  // option only when this is given AND canLogoRejectAndEdit says yes.
  onRejectAndEdit?: (logo: BaseLogo, note: string) => Promise<void>;
  onAssignCustomer: (customerId: number) => Promise<void>;
  // "Upload stands alone" (flag REACT_APP_UPLOAD_PENDING_ENABLED): the two
  // ways out of the rejected-upload dialog (remove the dead row + open the
  // New logo dialog / remove the row). Only rendered under the flag.
  onUploadRejectedUploadAnother?: () => void;
  onUploadRejectedBack?: () => void;
  // "Unassign customer" (flag REACT_APP_LOGO_UNASSIGN_ENABLED): the
  // wrapper's ONE DELETE on the popup's customer org. Optional - the
  // button renders nothing without it or with the flag off.
  onUnassignCustomer?: () => Promise<void>;
  onCreateDesign: (logo: BaseLogo) => void;
}

// Flag REACT_APP_UPLOAD_PENDING_ENABLED - build-time constant.
const uploadPendingEnabled = enviroment.uploadPendingEnabled;

export function LogoDetails(props: LogoDetails_VM) {
  const logo = props.logo;
  const minQuantity = getLogoMinQuantity(logo);
  const [orderQuantity, setOrderQuantity] = useState<number>(minQuantity);
  // Flag REACT_APP_LOGO_POPUP_FAST: the detail is patched into THIS instance
  // (no remount), so a minimum that the full GetLogo raises above the list
  // row's is applied here; a quantity the user already typed above it is
  // kept. Flag off: the wrapper remounts on the detail and the initializer
  // above re-runs, exactly as today.
  useEffect(() => {
    if (!enviroment.logoPopupFastEnabled) return;
    setOrderQuantity((quantity) =>
      quantity < minQuantity ? minQuantity : quantity
    );
  }, [minQuantity]);
  const { t, i18n } = useTranslation();

  const { options } = useLogoContext();
  const colorOptions = options.colors;
  const colorsEmbroidery = options.colorsEmbroidery;
  const { role } = useProfileContext();
  const { whiteLabel } = useWhiteLabelContext();
  // Flag REACT_APP_PDF_WAIT_SHARP_ENABLED: bounded wait for a sharp logo image
  // + a dialog instead of a silently blurred PDF. The apiClient is only read
  // by the PDF under that flag (re-fetch of an unsharp logo). Flag off = a
  // plain withToasts around the generator (as before) and a null dialog.
  const apiClient = useApiClient();
  // adoptKey: the wrapper REMOUNTS this component when the full GetLogo lands
  // (key "list-stub" -> "summary") - a download started before that must
  // hand its stop dialog (and its in-flight guard) over to the new instance.
  const { downloadPdf, sharpGateDialog } = usePdfDownloadWithSharpGate({
    colorHex: whiteLabel.colorHex,
    adoptKey: `logo:${logo?.id}`,
  });
  const { hidePrices, showCustomerPrices } = usePriceVisibility();
  // Sales price markup (flag priceMarkupEnabled): the fee rows below print
  // the sales price of the purchase fee (customer commission wins) - the
  // product rows go through PricesShort, which does the same. Inert while
  // off.
  const markup = useSalesMarkup();

  const cloningRestrictionReason = getCloningRestrictionReason(logo);

  // Check if logo has any customer prices available
  const hasCustomerPrices =
    logo.product?.prices?.some(
      (price) => price.adjustedCustomerPrice !== null,
    ) || false;

  // Determine if we should show price headers
  const isDraft = getLogoState(logo) === LogoState.Draft;
  // "Prices on their way" (flag productPendingEnabled): while the API worker
  // still owes the fresh product, the (old or missing) prices are hidden and
  // the badge takes their place. Always false with the flag off.
  const productPending = isLogoProductPending(logo);
  const shouldShowPriceHeaders =
    !hidePrices &&
    !isDraft &&
    !productPending &&
    (!showCustomerPrices || hasCustomerPrices);

  const [dialogOpen, setDialogOpen] = useState(false);
  const [approvalEmail, setApprovalEmail] = useState("");
  const [approvalConfirmationOpen, setApprovalConfirmationOpen] =
    useState(false);
  const [pendingApproval, setPendingApproval] = useState(false);
  const assignCustomerDialog = useDialog();
  const [includeLogoFees, setIncludeLogoFees] = useState(false);

  function handleAddToCart() {
    props.onAddToCart(logo, orderQuantity);
  }

  async function handleDownloadPdf() {
    try {
      await downloadPdf({
        run: (options) =>
          LogoPdfGenerator.generateLogoPdf(
            {
              logo: logo,
              vendorLogoUrl: whiteLabel.logoUrl || undefined,
              apiClient,
            },
            options,
          ),
        loadingMessage: t("logoList.generatingLogoPdf"),
        successMessage: t("logoList.logoPdfDownloaded"),
        errorMessage: t("logoList.logoPdfFailed"),
      });
    } catch (error) {
      // Error is already handled by withToasts (inside downloadPdf)
      console.error("Failed to generate PDF:", error);
    }
  }

  // Check if current user has pending approval status
  const hasCurrentUserPendingApproval = () => {
    return hasUserPendingApprovalStatus(logo.approval, role as number);
  };

  const startApprovalEmailFlow = () => {
    // If current user has pending approval, show confirmation dialog first
    if (hasCurrentUserPendingApproval()) {
      setApprovalConfirmationOpen(true);
      return;
    }
    // Otherwise proceed directly to email dialog
    setDialogOpen(true);
  };

  const handleApprovalConfirmation = () => {
    setApprovalConfirmationOpen(false);
    // Mark that approval is pending (don't approve yet)
    setPendingApproval(true);
    // Show email dialog
    setDialogOpen(true);
  };

  const endApprovalEmailFlow = () => {
    // If there's a pending approval, approve first before sending email
    if (pendingApproval) {
      props.onPlaceVerdict(logo, { approve: true });
      setPendingApproval(false);
    }
    props.onSendApproval(logo, approvalEmail);
  };

  const colors = getLogoColors(logo, colorOptions, colorsEmbroidery);

  // A logo whose every printed colour is near-white (e.g. "Numberset 5 cm hvid")
  // is invisible on the popup's white background - the sharp high-res render still
  // reads as faint grey ghosting. Detect it from the actual colour data (perceived
  // luminance, 0-255) and give ONLY those logos a subtle checkerboard behind the
  // image so the white print becomes visible; every other logo keeps the plain
  // white background unchanged. Mixed logos (at least one non-white colour) stay
  // white - their coloured parts are already visible.
  const isLightLogo =
    colors.length > 0 &&
    colors.every(
      (c) => 0.299 * c.red + 0.587 * c.green + 0.114 * c.blue > 235,
    );
  const lightLogoBgStyle: CSSProperties = {
    backgroundColor: "#e9edf2",
    backgroundImage:
      "linear-gradient(45deg,#d3dae3 25%,transparent 25%),linear-gradient(-45deg,#d3dae3 25%,transparent 25%),linear-gradient(45deg,transparent 75%,#d3dae3 75%),linear-gradient(-45deg,transparent 75%,#d3dae3 75%)",
    backgroundSize: "18px 18px",
    backgroundPosition: "0 0,0 9px,9px -9px,-9px 0",
  };

  let colorsElements = isDigital(logo) ? (
    <DigitalColorElement />
  ) : (
    colors.map((co) =>
      co.isIndigo ? (
        <DigitalColorElement key={co.id} showText={true} text={co.name} />
      ) : (
        <VectorColorElement
          key={co.id}
          showName={true}
          color={co}
          maxWidth="max-w-32"
          embroideryMethod={isEmbroideryTransferType(logo.transferMethod?.type)}
        />
      ),
    )
  );

  const additionalFees = logo.product?.additionalFees ?? [];
  additionalFees.sort((a, b) => {
    const getPriority = (name: string) => {
      const n = name.toLowerCase();
      if (
        n.includes("startup") ||
        n.includes("start-up") ||
        n.includes("opstart")
      )
        return 0;
      if (n.includes("film")) return 1;
      return 2;
    };

    const pA = getPriority(a.name);
    const pB = getPriority(b.name);

    if (pA !== pB) return pA - pB;
    return (a.quantity || 0) - (b.quantity || 0);
  });

  const calculateQuantityRange = (current: number, next: number) =>
    current +
    (!isNaN(next) && next > 0 && next > current ? " - " + (next - 1) : "+");

  let pricesToRender = logo.product?.prices ?? [];

  if (includeLogoFees) {
    pricesToRender = pricesToRender.map((p) => {
      const quantity = p.minQuantity || 1;
      let totalFeePrice = 0;
      let totalFeeCustomerPrice = 0;

      additionalFees.forEach((fee) => {
        const isStartup = ["startup", "start-up", "opstart", "film"].some((k) =>
          fee.name.toLowerCase().includes(k),
        );
        const feeQty = isStartup ? colors.length || 1 : (fee.quantity ?? 1);

        let unitPrice = fee.unitPrice ?? 0;
        let customerUnitPrice = fee.unitPrice ?? 0;

        if (fee.prices && fee.prices.length > 0) {
          const priceObj = getProductPrice(fee.prices, quantity);
          if (priceObj) {
            unitPrice = priceObj.adjustedPrice;
            customerUnitPrice =
              priceObj.adjustedCustomerPrice !== undefined &&
              priceObj.adjustedCustomerPrice !== null
                ? priceObj.adjustedCustomerPrice
                : priceObj.adjustedPrice;
          }
        }

        totalFeePrice += unitPrice * feeQty;
        totalFeeCustomerPrice += customerUnitPrice * feeQty;
      });

      const newPrice = { ...p };
      newPrice.adjustedPrice += totalFeePrice / quantity;
      if (newPrice.adjustedCustomerPrice !== undefined) {
        newPrice.adjustedCustomerPrice += totalFeeCustomerPrice / quantity;
      }
      return newPrice;
    });
  }

  return (
    <>
      {props.isLoading && <LoadingElement transparent />}
      {sharpGateDialog}
      {/* "The file was rejected" (flag REACT_APP_UPLOAD_PENDING_ENABLED): the
          worker's deterministic verdict on an upload opened from the list.
          Mounted under the flag only = the flag-off tree is unchanged. */}
      {uploadPendingEnabled && (
        <UploadRejectedDialog
          logo={logo}
          onUploadAnother={props.onUploadRejectedUploadAnother}
          onBack={props.onUploadRejectedBack}
        />
      )}
      <div>
        <BoxHeader2 className="flex flex-col">
          <LogoTitleHeader logo={logo} />
        </BoxHeader2>
        <BoxModalContent className={"w-[1000px] min-h-0 pb-8"}>
          <StrucRow>
            {cloningRestrictionReason && (
              <Tooltip title={t(cloningRestrictionReason)} placement={"right"}>
                <FontAwesomeIcon
                  className="text-[20px] text-status-pending-1"
                  icon={faTriangleExclamation}
                />
              </Tooltip>
            )}
            <StrucCol size={8} offset={2} className={"py-14 relative"}>
              {/* Definite box (w-full + fixed height) instead of max-h: with only a
                  max-height cap the box tracks the CURRENT image's natural size, so
                  every low-res -> high-res / stub -> detail transition could resize
                  it and make the image visibly jump. A CSS-driven box keeps every
                  state (blur placeholder, crossfade, plain) in exactly the same
                  frame - only sharpness changes. Same pattern as the design detail
                  popup (design-details.component.tsx). */}
              <LogoImage
                logo={logo}
                useHighRes={true}
                progressiveHighRes
                noPendingBlur={enviroment.logoPopupFastEnabled}
                scaleNameByHeight
                className={`${
                  isLightLogo ? "" : "bg-white"
                } object-contain rounded w-full h-[12rem] xl:h-[30rem]`}
                style={isLightLogo ? lightLogoBgStyle : undefined}
              />
            </StrucCol>
          </StrucRow>

          {props.detailStatus === "error" && (
            <StrucRow>
              <StrucCol>
                {/* The background GetLogo failed - everything shown below is
                    the (still correct) list data, but designCount and the
                    fresh high-res image never arrived. Discreet notice for
                    those detail fields only; the popup stays usable. */}
                <TypographyR className="flex items-center gap-x-2 text-status-pending-1 pb-2">
                  <FontAwesomeIcon icon={faTriangleExclamation} />
                  {t("logoList.detailsLoadFailed")}
                </TypographyR>
              </StrucCol>
            </StrucRow>
          )}
          <StrucRow>
            {/* min-w-0: this column is the flexible (unsized) flex item of the
                outer row. Flexbox min-width:auto let any wide child content
                (e.g. the admin sharing list before it wrapped) blow up the
                column's minimum width past the popup, wrapping the button
                column below as a narrow orphan. min-w-0 pins the layout to the
                popup width no matter what the columns contain. */}
            <StrucCol className={"!justify-start space-y-2 min-w-0"}>
              <StrucRow>
                <StrucCol size={3}>
                  <ColumnTypography>{t("logoList.detailsHeader")}</ColumnTypography>
                </StrucCol>
                <StrucCol size={2.5}>
                  <ColumnTypography>{t("logoList.colorsHeader")}</ColumnTypography>
                </StrucCol>

                <StrucCol size={2}>
                  <ColumnTypography>
                    {shouldShowPriceHeaders ? t("logoList.priceHeader") : ""}
                  </ColumnTypography>
                </StrucCol>
                <StrucCol size={2.5}>
                  <ColumnTypography>
                    {shouldShowPriceHeaders && additionalFees?.length
                      ? t("logoList.extraFeesHeader")
                      : ""}
                  </ColumnTypography>
                </StrucCol>
                <StrucCol size={1.5}>
                  <ColumnTypography>{t("logoList.statusHeader")}</ColumnTypography>
                </StrucCol>
              </StrucRow>
              <StrucRow>
                <StrucCol
                  className={
                    "whitespace-nowrap overflow-x-hidden overflow-ellipsis space-y-2 h-full justify-between"
                  }
                  size={3}
                >
                  <EditableLogoTitle
                    logo={logo}
                    onTitleChange={props.onTitleChange}
                  />
                  <TypographyR className="flex items-center gap-x-1">
                    <b>{t("logoList.size")} </b>
                    {LogoDimensions({ logo, format: "WWxYYmm" })}
                  </TypographyR>
                  <TypographyR className="flex items-center gap-x-1 capitalize">
                    <b>{t("type")} </b>
                    {/* Flag logoListI18nEnabled: type card (Transfer/Badge
                        translated, screen-print variants merged); the
                        conditions below keep comparing the RAW type. */}
                    {enviroment.logoListI18nEnabled
                      ? getTypeLabelFromRaw(logo.transferMethod.type, t)
                      : logo.transferMethod.type.toLowerCase() ===
                            "direk tryk" ||
                          logo.transferMethod.type.toLowerCase() ===
                            "screen print"
                        ? t("logoList.screenPrint")
                        : logo.transferMethod.type.toLowerCase() ===
                              "broderi" ||
                            logo.transferMethod.type.toLowerCase() ===
                              "embroidery"
                          ? t("logoList.embroidery")
                          : logo.transferMethod.type.toLowerCase()}
                  </TypographyR>
                  {(logo.transferMethod.type.toLowerCase() === "broderi" ||
                    logo.transferMethod.type.toLowerCase() === "embroidery") &&
                    (logo.stitches ?? 0) > 0 && (
                      <TypographyR className="flex items-center gap-x-1">
                        <b>{t("logoList.stitches")} </b>
                        {(logo.stitches as number).toLocaleString(
                          i18n.language,
                        )}
                      </TypographyR>
                    )}
                  {logo.transferMethod.type.toLowerCase() !== "direk tryk" &&
                    logo.transferMethod.type.toLowerCase() !== "screen print" &&
                    logo.transferMethod.type.toLowerCase() !== "broderi" &&
                    logo.transferMethod.type.toLowerCase() !== "embroidery" && (
                      <TypographyR className="flex items-center gap-x-1 capitalize">
                        <b>{t("logoList.method")} </b>
                        {enviroment.logoListI18nEnabled
                          ? getMethodLabel(
                              {
                                ...logo.transferMethod,
                                displayName: getTransferDisplayName(logo),
                              },
                              t,
                            )
                          : getTransferDisplayName(logo).toLowerCase()}
                      </TypographyR>
                    )}
                  {logo.logoType === LogoType.NameLogo &&
                    (logo as NameLogo).font && (
                      <TypographyR>
                        <b>{t("font")} </b>
                        {(logo as NameLogo).font}
                      </TypographyR>
                    )}
                  {!logo.isForAllCustomers && logo.customer && logo.customer.type !== "vendor" && (
                    <TypographyR {...CLARITY_MASK}>
                      <b>{t("customer")} </b>
                      {logo.customer.name}
                    </TypographyR>
                  )}
                  <TypographyR>
                    <b>{t("logoList.creationDate")} </b>
                    {formatDate(logo.createdAtUtc)}
                  </TypographyR>
                  <LogoDetailStorage logo={logo} />
                  {/* Logo sharing (Etape 3): who sees this logo and why.
                      Self-gated (admin + logoSharingEnabled flag). */}
                  <LogoSharingInfoSection logo={logo} />
                  {(logo as ImageLogo).status === LogoEditStatus.Done && (
                    <IconButton
                      key={"download-button"}
                      onClick={handleDownloadPdf}
                      // The PDF embeds displayImage.highResUrl, which the list
                      // stub only carries as a low-res fallback - a fast click
                      // before the full GetLogo lands (or after it failed)
                      // would silently produce a degraded PDF. Keep the button
                      // visible (no layout jump) but inert until the fresh
                      // high-res render is here.
                      disabled={props.detailStatus !== "ready"}
                      icon={<FontAwesomeIcon icon={faDownload} />}
                    >
                      {t("logoList.downloadPdf")}
                    </IconButton>
                  )}
                </StrucCol>
                <StrucCol className={"!justify-start"} size={2.5}>
                  <div className="flex flex-wrap flex-col">
                    {colorsElements}
                  </div>
                </StrucCol>

                <StrucCol className={"!justify-start"} size={2}>
                  {/* The badge follows the price column's own visibility
                      rule: a role that never sees prices (hidePrices) gets
                      no "prices" badge either - the button locks still
                      apply. */}
                  {productPending && !hidePrices && (
                    <ProductPendingBadge
                      pending={productPending}
                      sinceUtc={logo.productPendingSinceUtc}
                    />
                  )}
                  {/* Admin "Refresh prices now" (flag logoPriceRefreshNowEnabled):
                      ONE POST per click that evicts the supplier caches and
                      re-queues the price look-up; the badge above appears at
                      once (cache patch) and the existing poll clears it. Also
                      shown when nothing is pending - that is the point. Flag
                      off / not admin / not an image logo = null = the DOM as
                      today. Disabled until the background GetLogo has landed
                      so the cache patch hits a real detail entry. */}
                  <PriceRefreshNowButton
                    logo={logo}
                    detailStatus={props.detailStatus}
                    className="self-start"
                  />
                  {shouldShowPriceHeaders && (
                    <>
                      <PricesShort
                        prices={pricesToRender}
                        nLines={999}
                        showBadge
                      />
                      {additionalFees.length > 0 && (
                        <div className="flex items-center space-x-2 mt-2">
                          <Switch
                            checked={includeLogoFees}
                            onCheckedChange={setIncludeLogoFees}
                          />
                          <span className="text-xs">
                            {t("logoList.previewPricesWithFees")}
                          </span>
                        </div>
                      )}
                    </>
                  )}
                </StrucCol>
                <StrucCol className={"!justify-start pr-2"} size={2.5}>
                  {shouldShowPriceHeaders &&
                    additionalFees.map((fee, i) => (
                      <div key={i}>
                        <div>{orderLineTitleText(fee.name, t)}</div>
                        {fee.prices.map((p, j) => {
                          // If showing customer prices but adjustedCustomerPrice doesn't exist, don't show price
                          if (showCustomerPrices && !p.adjustedCustomerPrice) {
                            return null;
                          }

                          const priceToShow = markup.active
                            ? markup.price(
                                p.adjustedPrice,
                                p.adjustedCustomerPrice,
                              )
                            : showCustomerPrices
                              ? p.adjustedCustomerPrice
                              : p.adjustedPrice;

                          return (
                            <SimplePriceLine
                              key={j}
                              price={priceToShow!}
                              quantity={
                                fee.prices.length <= 1
                                  ? fee.name === "Film pr. farve" ||
                                    fee.name
                                      .toLowerCase()
                                      .includes("startup") ||
                                    fee.name
                                      .toLowerCase()
                                      .includes("start-up") ||
                                    fee.name.toLowerCase().includes("opstart")
                                    ? `${colors.length || 1} ${t("stk")}`
                                    : ""
                                  : `${
                                      calculateQuantityRange(
                                        p.minQuantity,
                                        fee.prices[j + 1]?.minQuantity,
                                      ) +
                                      " " +
                                      t("stk")
                                    }`
                              }
                              currency={p.currency}
                            />
                          );
                        })}
                      </div>
                    ))}
                </StrucCol>
                <StrucCol className={"!justify-start"} size={1.5}>
                  <LogoStatusElement logo={logo} />
                  {/* "Preparing logo…" (flag cloneInstantEnabled): the clone
                      still awaits its own supplier identity. Always false
                      with the flag off = no element. "Upload failed" (flag
                      uploadPendingEnabled) replaces it for a rejected
                      upload - false with the flag off = the line as today. */}
                  {isLogoUploadPending(logo) && !isUploadRejected(logo) && (
                    <ProductPendingBadge
                      variant="upload"
                      pending={true}
                      sinceUtc={logo.uploadPendingSinceUtc}
                      className="mt-1"
                      wrap
                    />
                  )}
                  {isUploadRejected(logo) && (
                    <UploadFailedBadge logo={logo} className="mt-1" wrap />
                  )}
                  {/* "Sending to supplier" (flag logoRejectAndEditNavEnabled):
                      the dealer's changes to a committed NAV logo are being
                      written to the supplier system under the same item
                      number. Guarded at the call site like its siblings, so
                      the flag-off tree is today's (no element, no hook).
                      `wrap` on the three status badges (flag
                      REACT_APP_LOGO_STATUS_BADGE_WRAP_ENABLED, read in
                      utils/functions/statusBadgeWrap only): the text wraps
                      inside this 1.5/12 cell instead of running past it -
                      with the flag off the prop is inert (today's classes). */}
                  {isLogoNavWriteBackPending(logo) && (
                    <NavWriteBackPendingBadge logo={logo} className="mt-1" wrap />
                  )}
                </StrucCol>
              </StrucRow>
            </StrucCol>
            <StrucCol size={2} className={"!justify-start space-y-3"}>
              <ButtonLayout
                role={role}
                {...props}
                onStartApproval={startApprovalEmailFlow}
                handleAddToCart={handleAddToCart}
                quantity={orderQuantity}
                setOrderQuantity={setOrderQuantity}
                onAssignCustomerClick={assignCustomerDialog.openDialog}
              />
            </StrucCol>
          </StrucRow>
        </BoxModalContent>
      </div>
      <EmailDialog
        open={dialogOpen}
        setOpen={setDialogOpen}
        email={approvalEmail}
        onEmailChange={setApprovalEmail}
        onSubmit={endApprovalEmailFlow}
      />
      <ApprovalConfirmationDialog
        open={approvalConfirmationOpen}
        onClose={() => setApprovalConfirmationOpen(false)}
        onApprove={handleApprovalConfirmation}
        logoTitle={logo.title}
      />
      <AssignCustomerDialog
        dialogOption={assignCustomerDialog}
        onConfirm={async (customerId) => {
          await props.onAssignCustomer(customerId);
          assignCustomerDialog.closeDialog();
        }}
        isLoading={props.isLoading}
      />
    </>
  );
}

function EditableLogoTitle({
  logo,
  onTitleChange,
}: {
  logo: BaseLogo;
  onTitleChange: (title: string) => void;
}) {
  const [title, setTitle] = useState(logo?.title ?? "");
  const [editable, setEditable] = useState(false);
  const { t } = useTranslation();

  const toggle = () => {
    if (editable) onTitleChange(title);
    setEditable(!editable);
  };

  //console.log(logo.Classification);

  return (
    <TypographyR className="editable-title-field">
      <b>{t("logoList.logoName")} </b>{" "}
      {editable ? (
        <input
          className="editable-title-field__input"
          type="text"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              toggle();
            }
          }}
        />
      ) : (
        <span className="editable-title-field__label">{logo.title}</span>
      )}
      {String(logo.Classification) !== "11" &&
        (editable ? (
          <FontAwesomeIcon
            icon={faCheck}
            onClick={toggle}
            className="cursor-pointer hover:opacity-50"
          />
        ) : (
          <EditIcon
            onClick={toggle}
            className="cursor-pointer hover:opacity-50"
          />
        ))}
    </TypographyR>
  );
}

function CreateDesignButton({
  logo,
  onCreateDesign,
}: {
  logo: BaseLogo;
  onCreateDesign: (logo: BaseLogo) => void;
}) {
  const { t } = useTranslation();
  return (
    <IconButton
      key={"create-design"}
      onClick={() => onCreateDesign(logo)}
      variant="success"
      icon={<FontAwesomeIcon icon={faShirt} />}
      width={"full"}
    >
      {t("logoList.createDesign")}
    </IconButton>
  );
}

interface ButtonLayoutProps extends LogoDetails_VM {
  role?: Role;
  quantity: number;
  handleAddToCart: () => void;
  setOrderQuantity: Dispatch<SetStateAction<number>>;
  onStartApproval: () => void;
  onAssignCustomerClick: () => void;
}
function ButtonLayout(props: ButtonLayoutProps): JSX.Element {
  const { t } = useTranslation();
  // Check if current user has pending approval status first
  if (hasUserPendingApprovalStatus(props.logo.approval, props.role as number)) {
    return <ButtonLayoutPending {...props} />;
  }

  const state = getLogoState(props.logo);
  switch (state) {
    case LogoState.Approved:
      return <ButtonLayoutStandard {...props} />;
    case LogoState.Pending:
      return <ButtonLayoutPending {...props} />;
    case LogoState.Rejected:
      return <ButtonLayoutRejected {...props} />;
    case LogoState.Draft:
      return <ButtonLayoutDraft {...props} />;
    case LogoState.Undefined:
      return <span>{t("logoList.stateUndefined")}</span>;
  }
}

function ButtonLayoutPending({
  role,
  logo,
  detailStatus,
  onPlaceVerdict,
  onRejectAndDelete,
  onRejectAndEdit,
  onSkipApproval,
  onStartApproval,
  onViewDesigns,
  onDeleteLogo,
  onCreateDesign,
  isLoading,
}: {
  role?: Role;
  logo: BaseLogo;
  detailStatus: LogoDetailStatus;
  onPlaceVerdict: (logo: BaseLogo, verdict: Verdict) => void;
  onRejectAndDelete: (logo: BaseLogo, note?: string) => void;
  onRejectAndEdit?: (logo: BaseLogo, note: string) => Promise<void>;
  onSkipApproval: (logo: BaseLogo) => void;
  onStartApproval: () => void;
  onViewDesigns: (logo: BaseLogo) => void;
  onDeleteLogo: (logo: BaseLogo) => void;
  onCreateDesign: (logo: BaseLogo) => void;
  isLoading?: boolean;
}) {
  return (
    <>
      <ApprovalVoting
        placeVerdict={(verdict) => onPlaceVerdict(logo, verdict)}
        approvalGroup={logo.approval!}
        rejectDelete={(reason) => onRejectAndDelete(logo, reason)}
        fullWidth={true}
        // Button lock (flag approvalPatchEnabled): the action handler's
        // isLoading disables Approve/Reject and shows the spinner while the
        // verdict PUT runs. Flag off = prop not passed = today's buttons.
        isLoading={enviroment.approvalPatchEnabled ? isLoading : undefined}
        // "Prices on their way" (flag productPendingEnabled) / "Preparing
        // logo…" (flag cloneInstantEnabled): Approve locked with a tooltip
        // while either worker still owes the logo. False = as today.
        productPending={isLogoActionLocked(logo)}
        lockVariant={logoActionLockVariant(logo)}
        // "Reject and fix it myself" (flag logoRejectAndEditEnabled): the
        // third reject option for the dealer on a logo Edit is shown for.
        // Flag off / customer / committed logo = prop absent = today's dialog.
        rejectAndEdit={
          onRejectAndEdit && canLogoRejectAndEdit(logo, role)
            ? (reason) => onRejectAndEdit(logo, reason)
            : undefined
        }
        // Flag logoRejectAndEditNavEnabled: a committed NAV logo - the
        // dialog's "Fix it myself" adds the hint that the item number stays
        // the same. Flag off / a KitMaker logo = prop absent = today's dialog.
        rejectAndEditNavHint={canRejectAndEditCommittedNavLogo(logo) || undefined}
      />
      {(role === Role.Admin || role === Role.Vendor) &&
        !hasUserPendingApprovalStatus(logo.approval, role as number) && (
          <SkipApprovalLogoButton logo={logo} onSkipApproval={onSkipApproval} />
        )}
      <StartApprovalButton logo={logo} onStartApproval={onStartApproval} />
      <ViewDesign
        logo={logo}
        onViewDesigns={onViewDesigns}
        detailStatus={detailStatus}
      />
      <Delete logo={logo} onDeleteLogo={onDeleteLogo} />
    </>
  );
}

function ButtonLayoutStandard({
  role,
  logo,
  detailStatus,
  quantity,
  handleAddToCart,
  setOrderQuantity,
  onCopyLogo,
  onStartApproval,
  onShowRejectionNote,
  onViewDesigns,
  onDeleteLogo,
  onAssignCustomerClick,
  onUnassignCustomer,
  onCreateDesign,
}: {
  role?: Role;
  logo: BaseLogo;
  detailStatus: LogoDetailStatus;
  quantity: number;
  handleAddToCart: () => void;
  setOrderQuantity: Dispatch<SetStateAction<number>>;
  onCopyLogo: (logo: BaseLogo) => void;
  onStartApproval: () => void;
  onShowRejectionNote: (logo: BaseLogo) => void;
  onViewDesigns: (logo: BaseLogo) => void;
  onDeleteLogo: (logo: BaseLogo) => void;
  onAssignCustomerClick: () => void;
  onUnassignCustomer?: () => Promise<void>;
  onCreateDesign: (logo: BaseLogo) => void;
}) {
  return (
    <>
      <AddToOrderButton
        logo={logo}
        role={role}
        quantity={quantity}
        setOrderQuantity={setOrderQuantity}
        onClick={handleAddToCart}
      />
      <CopyLogoButton logo={logo} onCopyLogo={onCopyLogo} />
      <AssignCustomerButton logo={logo} onClick={onAssignCustomerClick} />
      {enviroment.logoUnassignEnabled && (
        <UnassignCustomerButton logo={logo} onUnassign={onUnassignCustomer} />
      )}
      <StartApprovalButton logo={logo} onStartApproval={onStartApproval} />
      {/* <SeeNoteButton logo={logo} onShowRejectionNote={onShowRejectionNote} /> */}
      <CreateDesignButton logo={logo} onCreateDesign={onCreateDesign} />
      <ViewDesign
        logo={logo}
        onViewDesigns={onViewDesigns}
        detailStatus={detailStatus}
      />
      <Delete logo={logo} onDeleteLogo={onDeleteLogo} />
    </>
  );
}

export function ButtonLayoutRejected({
  role,
  logo,
  detailStatus,
  onEditLogo,
  onCopyLogo,
  onShowRejectionNote,
  onViewDesigns,
  onDeleteLogo,
  onSkipApproval,
  onCreateDesign,
}: {
  role?: Role;
  logo: BaseLogo;
  detailStatus: LogoDetailStatus;
  setOrderQuantity: Dispatch<SetStateAction<number>>;
  onEditLogo: (logo: BaseLogo) => void;
  onCopyLogo: (logo: BaseLogo) => void;
  onShowRejectionNote: (logo: BaseLogo) => void;
  onViewDesigns: (logo: BaseLogo) => void;
  onDeleteLogo: (logo: BaseLogo) => void;
  onSkipApproval: (logo: BaseLogo) => void;
  onCreateDesign: (logo: BaseLogo) => void;
}) {
  // Check if logo is committed (has been sent to production)
  const isCommitted =
    logo.product?.sku != null && !logo.product.sku.includes("UPLOAD_");
  // Flag logoRejectAndEditNavEnabled: a committed NAV logo the dealer
  // rejected themselves may be edited under the SAME item number (the API
  // writes the changes back to the supplier). False with the flag off, while
  // the write-back is pending, or for a rejection mirrored from the supplier
  // = today's gate.
  const canEdit = !isCommitted || canEditCommittedNavLogo(logo);

  return (
    <>
      {(role === Role.Admin || role === Role.Vendor) && (
        <SkipApprovalLogoButton logo={logo} onSkipApproval={onSkipApproval} />
      )}
      <CopyLogoButton logo={logo} onCopyLogo={onCopyLogo} />
      <SeeNoteButton logo={logo} onShowRejectionNote={onShowRejectionNote} />
      {canEdit && <EditLogoButton logo={logo} onEditLogo={onEditLogo} />}
      <ViewDesign
        logo={logo}
        onViewDesigns={onViewDesigns}
        detailStatus={detailStatus}
      />
      <Delete logo={logo} onDeleteLogo={onDeleteLogo} />
    </>
  );
}

function ButtonLayoutDraft({
  logo,
  detailStatus,
  onEditLogo,
  onViewDesigns,
  onDeleteLogo,
  onAssignCustomerClick,
  onUnassignCustomer,
  onCreateDesign,
}: {
  logo: BaseLogo;
  detailStatus: LogoDetailStatus;
  onViewDesigns: (logo: BaseLogo) => void;
  onEditLogo: (logo: BaseLogo) => void;
  onDeleteLogo: (logo: BaseLogo) => void;
  onAssignCustomerClick: () => void;
  onUnassignCustomer?: () => Promise<void>;
  onCreateDesign: (logo: BaseLogo) => void;
}) {
  // Check if logo is committed (has been sent to production)
  const isCommitted =
    logo.product?.sku != null && !logo.product.sku.includes("UPLOAD_");
  // Flag logoRejectAndEditNavEnabled: a committed NAV logo the dealer
  // rejected themselves may be edited under the SAME item number (the API
  // writes the changes back to the supplier). False with the flag off, while
  // the write-back is pending, or for a rejection mirrored from the supplier
  // = today's gate.
  const canEdit = !isCommitted || canEditCommittedNavLogo(logo);

  return (
    <>
      <AssignCustomerButton logo={logo} onClick={onAssignCustomerClick} />
      {enviroment.logoUnassignEnabled && (
        <UnassignCustomerButton logo={logo} onUnassign={onUnassignCustomer} />
      )}
      {canEdit && <EditLogoButton logo={logo} onEditLogo={onEditLogo} />}
      <ViewDesign
        logo={logo}
        onViewDesigns={onViewDesigns}
        detailStatus={detailStatus}
      />
      <Delete logo={logo} onDeleteLogo={onDeleteLogo} />
    </>
  );
}

export function AddToOrderButton({
  role,
  logo,
  quantity,
  setOrderQuantity,
  onClick,
}: {
  role?: Role;
  logo: BaseLogo;
  quantity: number;
  setOrderQuantity: Dispatch<SetStateAction<number>>;
  onClick: () => void;
}) {
  const { t } = useTranslation();
  const cartHidden = useCartHidden();
  // Flag oversizeSheetInlineRequestEnabled: null unless the guard is active
  // and this image logo is over the limit (then no stepper / "Add to order").
  const oversizeInline = useOversizeSheetInline({ logo });
  if (role === Role.Admin) {
    return <></>;
  }

  if (cartHidden) {
    return <></>;
  }

  // Check if logo has transfer type "transfer"
  const isTransferType = logo.transferMethod.type.toLowerCase() === "transfer";

  // If logo is not transfer type, don't show the Add to Order button
  if (!isTransferType) {
    return <></>;
  }

  // Check if this is a number logo (same logic as in logo-list-item)
  const hasCustomizableQuantity = ["NumberLogo", "NameLogo"].includes(
    logo?.logoType,
  );

  // For number logos, use the same dialog approach as logo-list-item
  const { component, open } = useAddLogoToOrderDialog(undefined, logo);

  // "Prices on their way" (flag productPendingEnabled): no add-to-order
  // while the product is pending - the cart would carry an old/missing
  // price. "Preparing logo…" (flag cloneInstantEnabled): nor while the
  // clone awaits its supplier identity. False = as today.
  const productPending = isLogoActionLocked(logo);
  const lockVariant = logoActionLockVariant(logo) ?? "product";

  function handleAddToCart() {
    if (productPending) return;
    if (hasCustomizableQuantity) {
      open();
    } else {
      onClick();
    }
  }

  // Oversize sheet guard (flag oversizeSheetInlineRequestEnabled): the
  // sheet size is no longer available - "Request new sheet size" in place
  // of the stepper + "ADD TO ORDER". Flag off = null = as today. After
  // every hook of this component (useAddLogoToOrderDialog above).
  if (oversizeInline) {
    return <OversizeSheetInlineRequest view={oversizeInline} layout="block" />;
  }

  // "Sending to supplier" (flag logoRejectAndEditNavEnabled, B3 Nichlas
  // 17/10: no ordering while the supplier write-back is pending - the price
  // is the old one until the re-import lands). False with the flag off.
  // AFTER every hook of this component: the API flips navWriteBackPending
  // on the mounted popup (the background GetLogo, the poll's re-read), and
  // an early return before useAddLogoToOrderDialog would change the hook
  // count between renders (React: "Rendered more hooks than during the
  // previous render").
  if (isLogoNavWriteBackPending(logo)) {
    return <></>;
  }

  return (
    <>
      {component}
      {!hasCustomizableQuantity && (
        <Stepper
          onValueChange={setOrderQuantity}
          min={1}
          value={quantity}
          width="full"
        />
      )}
      <ProductPendingLock locked={productPending} variant={lockVariant}>
        <IconButton
          key={"add-order"}
          onClick={handleAddToCart}
          variant="success"
          disabled={
            (!hasCustomizableQuantity &&
              !isValidLogoQuantity(logo, quantity)) ||
            productPending
          }
          icon={<FontAwesomeIcon icon={faCartPlus} />}
          width={"full"}
        >
          {t("logoList.addToOrderUpper")}
        </IconButton>
      </ProductPendingLock>
    </>
  );
}

function ViewDesign({
  logo,
  onViewDesigns,
  detailStatus,
}: {
  logo: BaseLogo;
  onViewDesigns: (logo: BaseLogo) => void;
  detailStatus: LogoDetailStatus;
}) {
  const { t } = useTranslation();

  // designCount is only computed by the full GetLogo - list rows ALWAYS carry
  // 0. While the modal renders on list data we therefore don't know yet
  // whether designs exist: render nothing until the count is known — the
  // button simply appears when the background fetch lands (the app's
  // long-standing behavior). A skeleton here read as a broken button when
  // the count turned out to be 0 and the bar vanished without ever becoming
  // one (user feedback 11/7).
  if (detailStatus === "loading") {
    return null;
  }

  // Fetch failed: designCount is unknown, so err on the actionable side and
  // keep the button - worst case the design list opens empty. Hiding it could
  // lock users out of designs that do exist.
  if (detailStatus === "ready" && logo.designCount === 0) {
    return <></>;
  }

  return (
    <IconButton
      key={"view-designs"}
      onClick={() => onViewDesigns(logo)}
      icon={<FontAwesomeIcon icon={faList} />}
      width={"full"}
    >
      {t("logoList.viewDesigns")}
    </IconButton>
  );
}

function CopyLogoButton({
  logo,
  onCopyLogo,
}: {
  logo: BaseLogo;
  onCopyLogo: (logo: BaseLogo) => void;
}) {
  const { t } = useTranslation();
  if (!shouldAllowCloning(logo)) return <></>;

  return (
    <IconButton
      key={"copy-logo"}
      onClick={() => onCopyLogo(logo)}
      icon={<FontAwesomeIcon icon={faClone} />}
      width={"full"}
    >
      {t("logoList.cloneLogo")}
    </IconButton>
  );
}

function EditLogoButton({
  logo,
  onEditLogo,
}: {
  logo: BaseLogo;
  onEditLogo: (logo: BaseLogo) => void;
}) {
  const { t } = useTranslation();
  return (
    <IconButton
      key={"edit-logo"}
      onClick={() => onEditLogo(logo)}
      variant="success"
      icon={<FontAwesomeIcon icon={faPenToSquare} />}
      width={"full"}
    >
      {t("logoList.editLogo")}
    </IconButton>
  );
}

function StartApprovalButton({
  logo,
  onStartApproval,
}: {
  logo: BaseLogo;
  onStartApproval: () => void;
}) {
  const { t } = useTranslation();
  // "Prices on their way" (flag productPendingEnabled) / "Preparing logo…"
  // (flag cloneInstantEnabled): approval-start would hit the API's guard -
  // lock with a tooltip meanwhile.
  const productPending = isLogoActionLocked(logo);
  return (
    <ProductPendingLock
      locked={productPending}
      variant={logoActionLockVariant(logo) ?? "product"}
    >
      <IconButton
        key={"approval-button"}
        onClick={productPending ? undefined : onStartApproval}
        variant="success"
        disabled={productPending || undefined}
        icon={<FontAwesomeIcon icon={faShare} />}
        width={"full"}
      >
        {t("logoList.sendLogo")}
      </IconButton>
    </ProductPendingLock>
  );
}

function SkipApprovalLogoButton({
  logo,
  onSkipApproval,
}: {
  logo: BaseLogo;
  onSkipApproval: (logo: BaseLogo) => void;
}) {
  const { t } = useTranslation();
  // "Prices on their way" (flag productPendingEnabled) / "Preparing logo…"
  // (flag cloneInstantEnabled): skip = commit, so it is locked with a
  // tooltip while either worker still owes the logo.
  const productPending = isLogoActionLocked(logo);
  return (
    <ProductPendingLock
      locked={productPending}
      variant={logoActionLockVariant(logo) ?? "product"}
    >
      <IconButton
        key={"skip-logo"}
        onClick={() => {
          if (productPending) return;
          onSkipApproval(logo);
        }}
        variant="success"
        disabled={productPending || undefined}
        icon={<FontAwesomeIcon icon={faForward} />}
        width={"full"}
      >
        {t("logoList.skipApproval")}
      </IconButton>
    </ProductPendingLock>
  );
}

function AssignCustomerButton({
  logo,
  onClick,
}: {
  logo: BaseLogo;
  onClick: () => void;
}) {
  const { role } = useProfileContext();
  const { t } = useTranslation();

  const shouldShow =
    logo.customer?.type == "vendor" &&
    String(logo.Classification) !== "11" &&
    !isPlaceholder(logo) &&
    role !== Role.EndUser;

  if (!shouldShow) return <></>;

  return (
    <IconButton
      key={"assign-customer"}
      onClick={onClick}
      icon={<FontAwesomeIcon icon={faUserPlus} />}
      width={"full"}
    >
      {t("logoList.assignCustomer")}
    </IconButton>
  );
}

function SeeNoteButton({
  logo,
  onShowRejectionNote,
}: {
  logo: BaseLogo;
  onShowRejectionNote: (logo: BaseLogo) => void;
}) {
  const { t } = useTranslation();
  return (
    <IconButton
      key={"see-note"}
      onClick={() => onShowRejectionNote(logo)}
      icon={<FontAwesomeIcon icon={faNoteSticky} />}
      width={"full"}
    >
      {t("logoList.seeNoteUpper")}
    </IconButton>
  );
}

function Delete({
  logo,
  onDeleteLogo,
}: {
  logo: BaseLogo;
  onDeleteLogo: (logo: BaseLogo) => void;
}) {
  const { role } = useProfileContext();
  const { t } = useTranslation();

  // Customer (EndUser) should not see delete button
  if (role === Role.EndUser) {
    return null;
  }

  if (String(logo.Classification) === "11") {
    return null;
  }

  // Global logos (offered to all customers) are never deleted from KitMaker - the API
  // refuses it too (GlobalLogoDeleteGuardEnabled). Say why instead of a dead button.
  if (logo.isForAllCustomers) {
    return (
      <p className="text-xs text-gray-600 italic text-center">
        {t("logoList.globalLogoNoDelete")}
      </p>
    );
  }
  return (
    <ConfirmationGuard
      anchor={
        <IconButton
          key={"new-logo"}
          variant="error"
          icon={<FontAwesomeIcon icon={faTrash} />}
          width={"full"}
        >
          {t("logoList.deleteLogoUpper")}
        </IconButton>
      }
      text={t("logoList.deleteLogoConfirm")}
      onAccept={() => onDeleteLogo(logo)}
    />
  );
}

// Returns an i18n key (translated at the render site) or null.
function getCloningRestrictionReason(logo: BaseLogo): string | null {
  const transferMethodRestricted = logo.transferMethod.isSublimation;

  if (transferMethodRestricted) {
    return "logoList.restrictedTransferMethod";
  }

  const hasRestrictedPantone = logo.colorDetails?.some(
    (color) => color.isBlocker || color.isIndigo || color.isSublimation,
  );

  if (hasRestrictedPantone) {
    return "logoList.restrictedColors";
  }

  return null;
}
